import { useDispatch } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat, datePickerCommonOpts, paintWeekendColors } from '../common/function';
import dayjs from 'dayjs';

function SettlementConfirm() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [pageRealtime, setPageRealtime] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(30)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [listDataRealtime, setListDataRealtime] = useState([])
    const [listTrxDataRealtime, setListTrxDataRealtime] = useState([])
    const [combineDataRealtime, setCombineDataRealtime] = useState([])
    const [reload, setReload] = useState(false)

    let tabList = ["익일", "즉결"]
    const [activeTab, setActiveTab] = useState("익일")

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    useEffect(() => {
        dispatch(change_Current_Location("정산확정내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setPreDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setNextDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수 (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "가맹점", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate, activeTab])

    useEffect(() => {
        ListDataRealtime()
    }, [pageRealtime, maxFirstPage, reload, preDate, nextDate, activeTab])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/settlement-confirm", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            // navigate("/");
        });
    }

    const ListDataRealtime = async () => {
        if (pageRealtime === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/settlement-confirm/realtime", {
            withCredentials: true,
            params: {
                page: pageRealtime,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListDataRealtime(tmp?.data ?? [])
                if (pageRealtime === 1) {
                    setListTrxDataRealtime(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxDataRealtime((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            // navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "거래일자", "width": "100px", "textAlign": "center" },
        { "no": 2, "text": "가맹점명", "width": "150px", "textAlign": "center" },
        { "no": 3, "text": "정산금액", "width": "100px", "textAlign": "center" },
        { "no": 4, "text": "수수료", "width": "100px", "textAlign": "center" },
        { "no": 5, "text": "실정산금액", "width": "100px", "textAlign": "center" },
        { "no": 6, "text": "등록자명", "width": "100px", "textAlign": "center" },
    ];

    const [checkedIds, setCheckedIds] = useState([]);

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            let list = listTrxData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                let date = data.trx_date.split(' ')

                tableBodyData.push([
                    { "no": 1, "text": date[0], "width": "100px", "textAlign": "center" },
                    { "no": 2, "text": data.co_nm, "width": "150px", "textAlign": "left" },
                    { "no": 3, "text": changeNum(Number(data.amt)), "width": "100px", "textAlign": "right" },
                    { "no": 4, "text": changeNum(Number(data.fee)), "width": "100px", "textAlign": "right" },
                    { "no": 5, "text": changeNum(Number(data.settlement_amt)), "width": "100px", "textAlign": "right" },
                    { "no": 6, "text": "관리자", "width": "100px", "textAlign": "center" },
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listTrxData])


    useEffect(() => {
        let tableBodyData = [];
        if (listTrxDataRealtime) {
            let list = listTrxDataRealtime ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                let date = data.trx_date.split(' ')

                tableBodyData.push([
                    { "no": 1, "text": date[0], "width": "100px", "textAlign": "center" },
                    { "no": 2, "text": data.co_nm, "width": "150px", "textAlign": "left" },
                    { "no": 3, "text": changeNum(Number(data.amt)), "width": "100px", "textAlign": "right" },
                    { "no": 4, "text": changeNum(Number(data.fee)), "width": "100px", "textAlign": "right" },
                    { "no": 5, "text": changeNum(Number(data.settlement_amt)), "width": "100px", "textAlign": "right" },
                    { "no": 6, "text": "관리자", "width": "100px", "textAlign": "center" },
                ])
            }
            setCombineDataRealtime(tableBodyData)
        }
    }, [listTrxDataRealtime])

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const observerRefRealtime = useRef(null);
    useEffect(() => {
        if (combineDataRealtime.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listDataRealtime.totCnt >= pageRealtime * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRefRealtime.current) {
            observer.observe(observerRefRealtime.current);
        }

        return () => {
            if (observerRefRealtime.current) {
                observer.unobserve(observerRefRealtime.current);
            }
        };
    }, [combineDataRealtime]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit
                        startInputRef={startInputRef}
                        endInputRef={endInputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={false}
                        state={true}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer"
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    <div className='excel-disable'>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                    </div>
                </div>
                <div style={{ width: "100%", maxWidth: "700px" }}>
                    {
                        activeTab == "익일"
                            ?
                            <List
                                tableHeaderData={tableHeaderData}
                                tableBodyData={listData?.totCnt ?? 0}
                                filter_tableBodyData={combineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                observerRef={observerRef}
                                nonePage={false}
                                scrollState={true}
                                spinner={spinner}
                                height={"700px"}
                            />
                            :
                            <List
                                tableHeaderData={tableHeaderData}
                                tableBodyData={listDataRealtime?.totCnt ?? 0}
                                filter_tableBodyData={combineDataRealtime}
                                page={pageRealtime}
                                setPage={setPageRealtime}
                                maxFirstPage={maxFirstPage}
                                observerRef={observerRefRealtime}
                                nonePage={false}
                                scrollState={true}
                                spinner={spinner}
                                height={"700px"}
                            />
                    }
                </div>
            </div>
        </div>
    )
}

export default SettlementConfirm